import React, { useEffect } from 'react'
import { useTittleContenidoStore } from '../context/tittleContenidoStore'
import { useAuthStore } from '../context/useAuthStore'
import imageWelcomeLogin  from '../assets/login-welcome.png'
const DashboardIndex = () => {
  const {setTittleContenido}: any = useTittleContenidoStore()
  const {Worker}: any = useAuthStore()
  useEffect(() => {
    setTittleContenido('Inicio')
  }, [])
  return (
    <div className='d-flex align-items-center flex-column mt-5'>
      <img src={imageWelcomeLogin} alt="Logotipo" className='logotipoTop' />
      <h1>Hola, {Worker?.displayName}</h1>
    </div>
  )
}

export default DashboardIndex